<template>
  <div class="bg-surface-default-low px-40 pb-40 pt-24">
    <nav class="mx-auto flex max-w-[1280px] flex-col gap-16">
      <aside class="flex gap-8">
        <p class="text-static-default-mid body-2 flex-1">
          {{ i18n(translations.categories) }}
        </p>
        <RevLink
          class="body-2-link"
          :to="universeURL"
          :tracking="{
            zone: 'mega menu',
            name: universeTitle,
            value: 'view_all',
          }"
          @click="$emit('click-item')"
          >{{ i18n(translations.see_all) }}</RevLink
        >
      </aside>
      <ul
        :aria-label="universeTitle"
        class="grid gap-32 md:grid-cols-3 lg:grid-cols-5"
      >
        <li v-for="item in items" :key="item.id" class="max-w-256">
          <RevLink
            class="body-2 flex flex-col gap-8"
            role="menuitem"
            :to="item.url"
            :tracking="{
              zone: 'mega menu',
              name: universeTitle,
              value: item.title,
            }"
            :underlined="false"
            @click="$emit('click-item')"
          >
            <RevIllustration
              v-if="item.image"
              :alt="item.title"
              class="rounded-lg"
              :height="960"
              :src="item.image"
              :width="1280"
            />
            <span class="text-action-default-hi body-1-bold">
              {{ item.title }}
            </span>
          </RevLink>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import type { Item } from '../../composables/useNavigation'

import translations from './NavMenuContent.translations'

const i18n = useI18n()

defineProps<{
  universeTitle: string
  universeURL: string
  items: Item[]
}>()

defineEmits(['click-item'])
</script>
